module.exports = __webpack_public_path__ + "img/building-confirm.8d6c87ee.svg";